@import '../../../globals/main.scss';
pn-breakpoints {
  width: 100%;
  .breakpoints {
    &--dotcom {
      width: 100%;
      background-color: aliceblue;
      text-align: center;
      margin-bottom: 2.4rem;

      background-color: aliceblue;
      .reference::before {
        content: 'less than 321';
      }

      @media screen and (min-width: 321px) {
        background-color: yellow;
        .reference::before {
          content: '321 (xs)';
        }
      }

      @media screen and (min-width: $min-width-sm) {
        background-color: aqua;
        .reference::before {
          content: '576 (sm)';
        }
      }

      @media screen and (min-width: $min-width-md) {
        background-color: red;
        color: #fff;
        .reference::before {
          content: '768 (md)';
        }
      }

      @media screen and (min-width: $min-width-lg) {
        background-color: green;
        color: #fff;
        .reference::before {
          content: '992 (lg)';
        }
      }

      @media screen and (min-width: $min-width-xl) {
        background-color: blue;
        color: #fff;
        .reference::before {
          content: '1200 (xl)';
        }
      }

      @media screen and (min-width: $min-width-xxl) {
        background-color: pink;
        .reference::before {
          content: '1640 (xxl)';
        }
      }

      @media screen and (min-width: 1920px) {
        background-color: orange;
        .reference::before {
          content: '1920 (fhd)';
        }
      }
    }

    &--tpl {
      //define breakpoints here
    }
  }
}
